import { logger } from '@talos/kyoko';
import { useMemo } from 'react';
import { OrgConfigurationKey, useOrgConfiguration } from '../../../../../providers';
import type { CareOrderParser } from '../types';

const SUPPORTED_PARSERS: string[] = ['aladdin', 'unqork'] satisfies CareOrderParser[];

/** Wraps the CareOrderImportParser org config with some type checking and reporting  */
export const useCareOrderImportParserFlag = (): CareOrderParser => {
  const { getConfig } = useOrgConfiguration();

  return useMemo(() => {
    const parser = getConfig(OrgConfigurationKey.CareOrderImportParser, 'aladdin');
    if (!SUPPORTED_PARSERS.includes(parser)) {
      logger.error(new Error('Unsupported ui.CareOrderImportParser set, defaulting to aladdin'), {
        extra: { SUPPORTED_PARSERS, parser },
      });
      return 'aladdin';
    } else {
      return parser as CareOrderParser;
    }
  }, [getConfig]);
};
